import axios, { Axios, AxiosInstance } from 'axios';
import React from 'react';
import { AuthContext } from 'react-oauth2-code-pkce';

const API_BASE_URL = '/api';

const ApiContext = React.createContext<AxiosInstance | null>(null);

export function useApiClient(): AxiosInstance {
  const instance = React.useContext(ApiContext);
  if (instance == null) {
    throw new Error("api client is not inside a provider");
  }
  return instance;
}

interface ApiProviderContextProps {
  children: React.ReactNode;
}

export function ApiProvider(params: ApiProviderContextProps): React.ReactElement {
  const { children } = params;

  const { token } = React.useContext(AuthContext);
  const apiClient = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  return <ApiContext.Provider value={apiClient}>{children}</ApiContext.Provider>;
}

